module.exports = "//static.hsappstatic.net/LoginUI/static-1.13510/img/passkey-logo.svg"